function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.404 1.816l9.528 9.527-9.528 9.527",
  stroke: "#001A5A",
  strokeWidth: 2.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "shaft",
  d: "M20.932 11.343H1.877",
  stroke: "#001A5A",
  strokeWidth: 2.5
});

function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSAiZGF0YTppbWFnZS9zdmcreG1sO2Jhc2U2NCxQSE4yWnlCM2FXUjBhRDBpTWpRaUlHaGxhV2RvZEQwaU1qTWlJSFpwWlhkQ2IzZzlJakFnTUNBeU5DQXlNeUlnWm1sc2JEMGlibTl1WlNJZ2VHMXNibk05SW1oMGRIQTZMeTkzZDNjdWR6TXViM0puTHpJd01EQXZjM1puSWo0S1BIQmhkR2dnWkQwaVRURXhMalF3TkRNZ01TNDRNVFU0VERJd0xqa3pNVFlnTVRFdU16UXpNVXd4TVM0ME1EUXpJREl3TGpnM01EVWlJSE4wY205clpUMGlJekF3TVVFMVFTSWdjM1J5YjJ0bExYZHBaSFJvUFNJeUxqVWlMejRLUEhCaGRHZ2dZMnhoYzNNOUluTm9ZV1owSWlCa1BTSk5NakF1T1RNeE5pQXhNUzR6TkRNeFNERXVPRGMyT1RZaUlITjBjbTlyWlQwaUl6QXdNVUUxUVNJZ2MzUnliMnRsTFhkcFpIUm9QU0l5TGpVaUx6NEtQQzl6ZG1jK0NnPT0i";
export { SvgArrowRight as ReactComponent };